import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M709.999-45.385v-120h-120v-59.999h120v-120h59.999v120h120v59.999h-120v120h-59.999zm0-395.384v-349.23h59.999v349.23h-59.999zM190.002-165.385v-624.614h59.999v624.614h-59.999zm259.999-480v-144.614h59.998v144.614h-59.998zm0 240v-144.614h59.998v144.614h-59.998zm0 240v-144.614h59.998v144.614h-59.998z"
      ></path>
    </svg>
  );
}

export default Icon;
